export default "__VITE_ASSET__64c0c8e0__"